import { render, staticRenderFns } from "./PageDialog.vue?vue&type=template&id=9ec45080&"
import script from "./PageDialog.vue?vue&type=script&lang=js&"
export * from "./PageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports